export default {
  Transactions: {
    HEADING: 'Transactions',
    DESCRIPTION:
      'Review how the recharge rules have been applied to transactions across your entities.',
    GROUP_BY: 'Group by:',
    FROM_ENTITY: 'Transactions from {{entity}}',
    APPORTIONMENT: '{{perc}} to {{entity}}',
    EXPENSES: 'Expenses',
    INCOME: 'Revenue',
    COST_PLUS: '(cost + {{perc}})',
    OVERRIDDEN:
      'The rule for this transaction has been manually overridden. It originally matched "{{rule}}"',
    OVERRIDDEN_NO_RULE_MATCH:
      'The rule for this transaction has been manually overridden. It originally did not match with any rules.',
    NONE: 'No transactions for {{name}} {{date}}',
    NONE_RANGE: 'No transactions for {{name}} between {{start}} and {{end}}',
    NONE_TYPE: 'No {{type}} transactions for {{name}} {{date}}',
    NONE_TYPE_RANGE:
      'No {{type}} transactions for {{name}} between {{start}} and {{end}}',
    HIDDEN: '{{name}} has no {{type}} rules other than Do not recharge',
    HIDDEN_ALL: '{{name}} has no rules other than Do not recharge',
    SHOW: 'Show transactions',
    SHOW_SHORT: 'Show',
    HISTORY: 'Transaction History',
    ARAP_HISTORY: 'History',
    DATE: 'Date',
    TYPE: 'Type',
    AMOUNT: 'Amount',
    RECHARGE: 'Recharge Transactions',
    RECHARGE_DESCRIPTION:
      'The recharges arising from the transactions in step 1 may result in subsequent recharges if posted within the same period.',
    RECHARGE_PRO_RATA:
      'The Mayday Rule has been prorated based on the number of days in this recharge period.',
    RECHARGE_DATE:
      'Tell us when your recharges will be posted and review how the recharge transactions are treated. You can choose posting type and other settings in the next step.',
    FUTURE_RECHARGES:
      'Mayday will not include recharge transactions in the calculation since you are posting them into a later period. These transactions will be treated as normal recharge transactions when you run recharges for the period you posted them into.\n\nTo include these transactions in this calculation, set the posting date to {{period}}.',
    NO_REFERENCE: 'No reference',
    DIFFERENCES: ['{{count}} item differs', '{{count}} items differ'],
    SETTLED_ROWS: 'Hide settled rows',
    ORIGINAL_INVOICE: 'Original invoice for',
    PAYMENT: 'Payment',
    PREPAYMENT: 'Prepayment',
    OVERPAYMENT: 'Overpayment',
    CREDIT_NOTE_PAYMENT: 'Credit note allocated',
    INVOICE_ALLOCATION: 'Allocated to invoice',
    Table: {
      COST: 'Cost',
      REVENUE: 'Revenue',
      RULE_APPLIED: 'Rule applied',
      RECHARGE: 'Recharge',
    },
    NEXT_STEP: 'Next step: {{step}}',
    LINKED_CONTACT: 'Billable expense for {{name}}',
    ONLY_NEW: 'New only:',
    ONLY_NEW_TOOLTIP:
      'Show only transactions which were added after this calculation was locked on {{date}}',
    NO_SEARCH_RESULTS: 'No transactions matching "{{searchTerm}}" were found.',
    NO_NEW: 'No new transactions in {{entity}} since {{lockDate}}',
    BatchChange: {
      BODY: [
        'Update rule applied to {{count}} transaction',
        'Update rule applied to {{count}} transactions',
      ],
      UPDATE: 'Update',
    },
    CREATE_ADHOC: [
      'Create ad-hoc recharge for this transaction',
      'Create ad-hoc recharge for these transactions',
    ],
  },
};
